// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetCompanyForUserRequestModel from '../../model/get-company-for-user-request-model';
import GetCompanyForUserRequestDTO from '../dto/get-company-for-user-request-dto';
import dtoSchema from '../schemas/get-company-for-user-request-schema';

export default abstract class GetCompanyForUserRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetCompanyForUserRequestDTO>) {
    super();
    if (data) {
      this.userId = data.userId;
    }
  }
  /**
  * @type {int64}
  */
  userId?: number;

  static toModel(dto: DeepPartial<GetCompanyForUserRequestDTO>): GetCompanyForUserRequestModel;
  static toModel(dto: DeepPartial<GetCompanyForUserRequestDTO> | undefined | null): GetCompanyForUserRequestModel | undefined;
  static toModel(dto: DeepPartial<GetCompanyForUserRequestDTO> | undefined | null): GetCompanyForUserRequestModel | undefined {
    return dto ? new GetCompanyForUserRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetCompanyForUserRequestModel> | GetCompanyForUserRequestModel): GetCompanyForUserRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      userId: unwrapped.userId,
    } as GetCompanyForUserRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetCompanyForUserRequestModel, can not map to GetCompanyForUserRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
